<template>
  <div class="quotation-form">
    <button class="quotation-form__goback" @click="handleBackTo" aria-label="Botão para retroceder no preenchimento do formulário">
      <i class="icon icon__go-back" />
      voltar
    </button>
    <div class="quotation-form__steps steps">
      <div :class="`steps__progress-bar steps__progress-bar--${quotation.step}`"></div>
      <button :class="`steps__step steps__step-1 ${quotation.step >= 1 && 'active'}`" @click="goToStep" data-step="1" aria-label="Botão para ir para a primeira etapa de preenchimento do formulário">1</button>
      <button :class="`steps__step steps__step-2 ${quotation.step >=2 && 'active'}`" @click="goToStep" data-step="2" aria-label="Botão para ir para a segunda etapa de preenchimento do formulário">2</button>
      <button :class="`steps__step steps__step-3 ${quotation.step === 3 && 'active'}`" @click="goToStep" data-step="3" aria-label="Botão para ir para a terceira etapa de preenchimento do formulário">3</button>
      <span :class="`steps__errorMessage ${stepErrorMessage && 'visible'}`">{{ stepErrorMessage }}</span>
    </div>
    <slot></slot>
  </div>
</template>

<script>
import PersonalDataForm from "./PersonalDataForm";
import AddressDataForm from "./AddressDataForm";
import FinancialDataForm from "./FinancialDataForm";

import handleLoadLocalStorage from '../../mixins/handleLoadLocalStorage';

import { mapState, mapActions } from "vuex";

export default {
  name: "QuotationForm",
  props: {
    step: {
      type: Number,
      required: true,
    },
  },
  components: {
    PersonalDataForm,
    AddressDataForm,
    FinancialDataForm
  },
  data() {
    return {
      stepErrorMessage: ""
    };
  },
  computed: {
    ...mapState(["quotation"])
  },
  mixins: [handleLoadLocalStorage],
  methods: {
    ...mapActions(["setQuotationStepDecrement", "setQuotationStep"]),
    goToStep: function({ target }) {
      const SELF = this;
      const step = parseInt(target.dataset.step);
      const progress = this.quotation.progress;
      const mapStepRoute = {
        1: "/cotacao/dados-pessoais",
        2: "/cotacao/endereco",
        3: "/cotacao/dados-financeiros"
      }

      function setErrorMessage(msg) {
        SELF.stepErrorMessage = msg;
        setTimeout(function() {
          SELF.stepErrorMessage = "";
        }, 5000);
      }
      if (progress >= step) {
        SELF.stepErrorMessage = "";
        SELF.setQuotationStep(step);
        this.$router.push(mapStepRoute[step]);
      } else {
        const msg = `Você só avançou até o passo ${SELF.quotation.progress}. Preencha os campos restantes para prosseguir.`;
        setErrorMessage(msg);
      }
    },
    handleBackTo: function() {
      if (this.quotation.step === 1) {
        this.$router.push("/");
      } else if (this.quotation.step > 1) {
        this.$router.go(-1);
      }
      this.setQuotationStepDecrement();
    }
  },
  mounted() {
    window.scrollTo(0,0);    
    const { started, sentToDataBase } = this.quotation;
    if(started && !sentToDataBase) {
      this.setQuotationStep(this.step);
    } else {
      this.$router.push("/")
    }
  }
};
</script>

<style lang="scss">
.quotation-form {
  padding: $space__st;
  
  &__goback,
  &__goback:active,
  &__goback:focus {
    width: auto;
    margin-bottom: $space__md;
    color: $color__primary;
    font-weight: 700;
    text-transform: uppercase;
    @include fade-in;
    cursor: pointer;

    .icon {
      display: block;
      text-align: left;
    }
  }

  .steps {
    position: relative;
    display: flex;
    width: 90vw;
    margin: 0 auto 100px auto;
    flex-wrap: wrap;
    justify-content: space-between;

    &__progress-bar {
      position: absolute;
      top: 50%;
      left: 0;
      width: 100%;
      height: $space__xs;
      background-image: linear-gradient(90deg, $color__gray, $color__gray 100%);
      transform: translateY(-50%);

      &--1,
      &--2,
      &--3 {
        &:before {
          content: "";
          display: block;
          height: $space__xs;
          background: $color__primary;
          transition: width 0.5s ease-in-out;
        }
      }

      &--1 {
        &:before {
          width: 0;
        }
      }

      &--2 {
        &:before {
          width: 50%;
        }
      }

      &--3 {
        &:before {
          width: 100%;
        }
      }
    }

    &__step {
      position: relative;
      width: $space__st;
      height: $space__st;
      color: $color__white;
      background-color: $color__gray;
      border-radius: 50%;
      cursor: pointer;
      z-index: 1;

      &:after {
        position: absolute;
        top: 110%;
        color: $color__black;
      }

      &-1 {
        &:after {
          content: "Dados pessoais";
          left: 0;
          text-align: left;
        }
      }

      &-2 {
        &:after {
          content: "Endereço";
          left: 0;
          text-align: center;
          transform: translateX(-35%);
        }
      }

      &-3 {
        &:after {
          content: "Dados financeiros";
          text-align: right;
          right: 0;
        }
      }

      &.active {
        background-color: $color__primary;
        transition: background-color 0.3s ease-in-out 0.5s;
      }
    }

    &__errorMessage {
      position: absolute;
      top: 200%;
      left: 50%;
      width: 100%;
      padding: $space__md  0;
      flex: 1 1 100%;
      font-size: $font-size__sm;
      color: $color__red;
      text-align: center;
      opacity: 0;
      visibility: hidden;
      transition: all 0.3s ease-in;
      transform: translateX(-50%);
      will-change: opacity, visibility;

      &.visible {
        opacity: 1;
        visibility: visible;
      }

      @include breakpoint($desk__min--sm) {
        font-size: $font-size__md;
      }
    }
  }
}
</style>